import { render } from "./PreViewImageList.vue?vue&type=template&id=3248d5f2&scoped=true"
import script from "./PreViewImageList.vue?vue&type=script&lang=js"
export * from "./PreViewImageList.vue?vue&type=script&lang=js"

import "./PreViewImageList.vue?vue&type=style&index=0&id=3248d5f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3248d5f2"]])

export default __exports__